// If any routes are only intended for authenticated users,
// please add here to direct to /login route
export const SECURE_ROUTES = new Set([
  '/account/addresses',
  '/account/offers',
  '/account/orders',
  '/account/orders/[orderNumber]',
  '/account/payments',
  '/account/preferences',
  '/account/profile',
  '/account/wants',
]);
